module.exports = __webpack_public_path__ + "static/media/gf.38dfa23a.svg";